import { BlocksPost } from '../../../components/Snippet'

export default {
  Component: BlocksPost,
  title: 'How Biocentrism Collapses Its Wave Function In The Final Chapter',
  path: 'physics/biocentrism',
  tags: [],
  date: '2016-11-23 19:09',
}
